module.exports = function(service) {
    'use strict';
    service.factory('editorExludeShortcode',editorExludeShortcode);
	editorExludeShortcode.$inject=[];
	function editorExludeShortcode() {
            return function(content,aiRequest) {
                if(!content) return '';
                var cleanContent = content
                // Remove custom elements first (using [\s\S] instead of . for multiline)
                .replace(/<captionblock[^>]*>[\s\S]*?<\/captionblock>/g, '')
                .replace(/<galleryblock[^>]*>[\s\S]*?<\/galleryblock>/g, '')
                .replace(/<embedblock[^>]*>[\s\S]*?<\/embedblock>/g, '')
                // Remove shortcodes that remain in visual mode
                .replace(/\[video[^\]]*\]/g, '')
                .replace(/\[poll[^\]]*\][\s\S]*?\[\/poll\]/g, '')
                .replace(/\[rating[^\]]*\][\s\S]*?\[\/rating\]/g, '')
                .replace(/\[quote[^\]]*\]([\s\S]*?)\[\/quote\]/g, '<blockquote>$1</blockquote>')
                .replace(/\[readalso[^\]]*\][\s\S]*?\[\/readalso\]/g, '')
                .replace(/\[liveblog[^\]]*\][\s\S]*?\[\/liveblog\]/g, '')
                if(aiRequest) {
                    cleanContent = cleanContent.replace(/<summaryblock>[\s\S]*?<\/summaryblock>/g, '');
                } else {
                    // For non-AI case, process summary blocks
                    cleanContent = cleanContent.replace(/<summaryblock>\[summary\]([\s\S]*?)\[\/summary\]<\/summaryblock>/g, function(match, content) {
                        // Split by |*| and wrap each part in paragraph
                        var facts = content.split(/\|\*\|/).filter(function(fact) {
                            return fact.trim();
                        });
                        var formattedContent = facts.map(function(fact) {
                            return '<p>' + fact.trim() + '</p>';
                        }).join('');
                        return formattedContent;
                    });
                }
                return cleanContent;
            }
    }
};  



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/editorExludeShortcodeServices.js
// module id = 599
// module chunks = 0